import { IDictionary } from '@app/core/common.model';

export const CDatesByScreenSize: IDictionary<number> = {
  xsmall: 4,
  small: 5,
  medium: 6,
  large: 6,
  xlarge: 6
};

export const CSessionRowByScreenSize: IDictionary<number> = {
  xsmall: 3,
  small: 4,
  medium: 4,
  large: 5,
  xlarge: 5
};

export const CDefaultNumDates = 5;

export const CMobileScreenSizes = ['XSmall', 'Small'];
